/**
 * RootRedirect — what "/" resolves to now that the (beta) marketing landing page
 * has been removed. There is no public front page: a signed-in visitor goes
 * straight to the app (/v4 → capability-aware home via DefaultLanding), and
 * everyone else goes to sign-in.
 */

import { Navigate } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';

export default function RootRedirect() {
  const { isAuthenticated, loading } = useAuth();

  // Wait for the auth check so we don't bounce a signed-in user to /auth.
  if (loading) return null;

  return <Navigate to={isAuthenticated ? '/v4' : '/auth'} replace />;
}
